import { useIsSubsidiariesNoticeDisplayed } from "~/components/layout/SubsidiariesNotice";
import { useIsUserNoticesDisplayed } from "~/components/layout/UserNotices";

export const useIsAnyNoticeDisplayed = () => {
  const { isUserNoticesDisplayed } = useIsUserNoticesDisplayed();
  const { isSubsidiariesNoticeDisplayed } = useIsSubsidiariesNoticeDisplayed();

  return { isAnyNoticeDisplayed: isUserNoticesDisplayed || isSubsidiariesNoticeDisplayed };
};
